import styled from 'styled-components'
import { StyledHistory } from './ChatHistoryList'
import { useModal } from 'hooks'
import { useParams } from 'react-router-dom'
import HistoryPlaceholder from './HistoryPlaceholder'
import { useAppModeContext } from 'context/AppModeContext'

export interface ImageInterface {
    width: string
    height: string
    url: string
    prompt: string
    style: string
    model: string
    cUrl: string
}

const ImagesHistoryList = () => {
    const { openModal } = useModal()
    const { account_id } = useAppModeContext()

    const { id } = useParams()
    const imagesHistoryStorage = `imagesHistory-${id}-${account_id}`

    const handleOpenModal = (data: ImageInterface) => {
        openModal({ name: 'images-modal', data: data })
    }

    const images: ImageInterface[] = JSON.parse(localStorage.getItem(imagesHistoryStorage) || '[]')

    return (
        <StyledHistory>
            <StyledImagesWrapper>
                {images.map((image: ImageInterface, index: number) => (
                    <StyledImage
                        key={index}
                        src={image.url}
                        onClick={() => handleOpenModal(image)}
                    />
                ))}
            </StyledImagesWrapper>

            {images?.length === 0 && <HistoryPlaceholder item={'image'} />}
        </StyledHistory>
    )
}

export default ImagesHistoryList

const StyledImagesWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;

    width: 100%;

    overflow: auto;
`

const StyledImage = styled.img`
    object-fit: contain;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;

    border-radius: 8px;

    scale: 0.98;

    &:hover {
        scale: 1;
        cursor: pointer;
    }
`
